export function convertState(state) {
    switch (state) {
        case "AC":
            return "acre";
            break;
        case "AL":
            return "alagoas";
            break;
        case "AM":
            return "amazonas";
            break;
        case "AP":
            return "amapa";
            break;
        case "BA":
            return "bahia";
            break;
        case "CE":
            return "ceara";
            break;
        case "DF":
            return "distrito-federal";
            break;
        case "ES":
            return "espirito-santo";
            break;
        case "GO":
            return "goias";
            break;
        case "MA":
            return "maranhao";
            break;
        case "MS":
            return "mato-grosso-do-sul";
            break;
        case "MT":
            return "mato-grosso";
            break;
        case "PA":
            return "para";
            break;
        case "PB":
            return "paraiba";
            break;
        case "PE":
            return "pernambuco";
            break;
        case "PI":
            return "piaui";
            break;
        case "PR":
            return "parana";
            break;
        case "RJ":
            return "rio-de-janeiro";
            break;
        case "RN":
            return "rio-grande-do-norte";
            break;
        case "RO":
            return "rondonia";
            break;
        case "RR":
            return "roraima";
            break;
        case "RS":
            return "rio-grade-do-sul";
            break;
        case "SC":
            return "santa-catarina";
            break;
        case "SE":
            return "sergipe";
            break;
        case "SP":
            return "sao-paulo";
            break;
        case "TO":
            return "tocantins";
            break;
        default:
            return "";
            break;
    }
    }

export function convertCity(city : string) {
    return (city?.trim().replace(' ','-').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
}
